/* eslint-disable no-param-reassign */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerDatabaseDestinationComponent', [
    'DesignerBaseDatabaseDestinationComponent',

    function (DesignerBaseDatabaseDestinationComponent) {
      function DesignerDatabaseDestinationComponent() {
        DesignerBaseDatabaseDestinationComponent.apply(this);

        this.batch_size = null;
        this.parallel = null;
        this.w = null;
        this.split_by_field = null;
      }

      DesignerDatabaseDestinationComponent.prototype = new DesignerBaseDatabaseDestinationComponent();

      DesignerDatabaseDestinationComponent.prototype.getData = function () {
        const data = DesignerBaseDatabaseDestinationComponent.prototype.getData.call(this);

        _.extend(data, {
          batch_size: this.batch_size || this.defaults.batch_size,
          operation_type: this.operation_type || this.defaults.operation_type,
          parallel: this.parallel || this.defaults.parallel,
          identity_insert_sql_server: this.identity_insert_sql_server || this.defaults.identity_insert_sql_server,
          single_transaction_per_batch: angular.isDefined(this.single_transaction_per_batch)
            ? this.single_transaction_per_batch
            : this.defaults.single_transaction_per_batch,
          split_by_field: this.split_by_field,
        });

        return data;
      };

      DesignerDatabaseDestinationComponent.prototype.getFormData = function () {
        const data = DesignerBaseDatabaseDestinationComponent.prototype.getFormData.call(this);

        return data;
      };

      DesignerDatabaseDestinationComponent.prototype.setFormData = function (data) {
        data.single_transaction_per_batch = Boolean(data.single_transaction_per_batch);

        DesignerBaseDatabaseDestinationComponent.prototype.setFormData.call(this, data);
      };

      DesignerDatabaseDestinationComponent.prototype.setData = function (data) {
        this.batch_size = data.batch_size;
        this.parallel = data.parallel;
        this.operation_type = data.operation_type;
        this.single_transaction_per_batch = data.single_transaction_per_batch;
        this.split_by_field = data.split_by_field;
        this.identity_insert_sql_server = data.identity_insert_sql_server;

        DesignerBaseDatabaseDestinationComponent.prototype.setData.call(this, data);
      };

      DesignerDatabaseDestinationComponent.prototype.getSchema = function () {
        const schema = DesignerBaseDatabaseDestinationComponent.prototype.getSchema.call(this);

        return schema;
      };

      return DesignerDatabaseDestinationComponent;
    },
  ]);
})(window.angular);
